interface FaqItem {
  question: string;
  answer: string;
}

interface FaqSectionProps {
  items: FaqItem[];
  bgColor?: string;
}

export default function FaqSection({
  items,
  bgColor = "bg-white",
}: FaqSectionProps) {
  return (
    <section className={`${bgColor} py-16 md:py-24`} id="faq">
      <div className="w-full px-4 md:px-8 max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <span className="text-gold text-sm tracking-[4px] font-bold block mb-2">
            FAQ
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-navy">
            よくあるご質問
          </h2>
          <div className="w-16 h-1 bg-gold mx-auto mt-4 rounded-full" />
        </div>
        <div className="space-y-4">
          {items.map((item, i) => (
            <div
              key={i}
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
              className="bg-white rounded-xl border border-gray-200 overflow-hidden transition-all duration-200 hover:border-gold/50 hover:shadow-md"
            >
              <div className="p-6 md:p-8">
                <h3
                  itemProp="name"
                  className="text-lg font-bold text-navy mb-3 flex items-start gap-3"
                >
                  <span className="w-8 h-8 shrink-0 rounded-full bg-gold/10 flex items-center justify-center text-gold text-sm font-bold">
                    Q
                  </span>
                  {item.question}
                </h3>
                <div
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <p
                    itemProp="text"
                    className="text-gray-600 leading-relaxed pl-11"
                  >
                    {item.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}